import { Component } from 'themes/interfaces';

export default {
  layout: {
    button: {
      height: 48,
    },
    height: {
      page: 300,
    },
    navbar: {
      height: 80,
    },
    section: {
      default: {
        xs: 960,
        md: "100%",
        lg: "70%",
        xl: "60%",
      }
    },
    tab: {
      height: 32,
    }
  }

} as Component;
